import { useSelector } from 'react-redux'

import { isPrintAssetSelector } from '@/selectors'
import { routeFor } from '@/utils/router'
import settings from '@/utils/settings'
import { translate } from '@/utils/translations'

const ViewAllPoliciesLink = () => {
  const isPrintAsset = useSelector(isPrintAssetSelector)
  const policyUrl = isPrintAsset
      ? settings.virtual_store_return_policy_link_url
      : routeFor('refundPolicy')

  return (
    <a
      className='type--ocean6 underline'
      href={policyUrl}
      rel='noreferrer noopener'
      target='_blank'
    >
      {translate('order_history.link.view_all_return_policies')}
      <span className="sr-only">
        {translate('common.opens_in_new_window')}
      </span>
    </a>
  )
}

export default ViewAllPoliciesLink
